import { useTranslate } from '@/hooks'
import { useAppSelector } from '@/redux/hooks'
import { getDate } from '@/utils'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

const HoffTopBar: React.FC = () => {
    const orderNumber = useAppSelector(
        (store) =>
            store.returnsApi.order.response.order?.identification
                ?.customer_printed_order_id
    )
    const date = useAppSelector(
        (store) => store.returnsApi.order.response.order?.purchased_at
    )
    const { t } = useTranslation()
    const { pathname } = useLocation()
    const { i18n } = useTranslation()
    const purchaseDate = date ? getDate(date, i18n.language, 'long') : ''
    const { translate } = useTranslate()
    const navigate = useNavigate()
    const isSuccess = pathname.includes('success')

    return (
        <>
            <div className="mt-4 flex w-full flex-col items-start gap-3 md:mt-12">
                {isSuccess ? null : (
                    <a
                        onClick={() => navigate(-1)}
                        className="flex cursor-pointer items-center gap-3"
                    >
                        <span>
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                fill="none"
                                width="10"
                                viewBox="0 0 10 10"
                            >
                                <path
                                    d="M7 1 3 5l4 4"
                                    stroke="currentColor"
                                    strokeLinecap="square"
                                ></path>
                            </svg>
                        </span>
                        <span className="font-haas text-[0.5em] font-light text-neutral-600">
                            {translate('top_bar_back')}
                        </span>
                    </a>
                )}

                <span className="mt-2 font-haas text-xl font-light">
                    {t('tracking_layout.order')} {orderNumber}
                </span>
                <span className="font-haas text-sm font-light">
                    {t('tracking_layout.order')} {purchaseDate}
                </span>
            </div>
        </>
    )
}

export default HoffTopBar
